import { html } from 'lit';
const DatabaseListView =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zM3.75 6c0-.69.56-1.25 1.25-1.25h2.25v3.5h-3.5zm3.5 3.75h-3.5v3.5h3.5zm1.5 3.5v-3.5h11.5v3.5zm-1.5 1.5h-3.5V18c0 .69.56 1.25 1.25 1.25h2.25zm1.5 4.5v-4.5h11.5V18c0 .69-.56 1.25-1.25 1.25zm0-11v-3.5H19c.69 0 1.25.56 1.25 1.25v2.25z" clip-rule="evenodd"/>
  </svg>
`;
export default DatabaseListView;
